import { graphql } from 'react-relay';

export default graphql`
    query footerRootQuery($userId: String = "", $hasUserId: Boolean!) {
        viewer {
            ...Footer_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    userId: '',
};
